import { negativePrefix, worldWide } from "./consts";
import type { Matcher } from "./index";

export interface GeoData {
  region: string;
  country: string;
  continent: string;
}

function isGeoExcluded(
  countryList: string[],
  country: string,
  region: string,
  continent: string,
): boolean {
  return (
    countryList.includes(`${negativePrefix}${country}`) ||
    countryList.includes(`${negativePrefix}${country}-${region}`) ||
    countryList.includes(`${negativePrefix}${worldWide}-${continent}`)
  );
}

function isGeoIncluded(
  countryList: string[],
  country: string,
  region: string,
  continent: string,
): boolean {
  return (
    countryList.includes(worldWide) ||
    countryList.includes(`${worldWide}-${continent}`) ||
    countryList.includes(country) ||
    countryList.includes(`${country}-${region}`)
  );
}

export const regionMatcher = (geo: GeoData): Matcher => {
  const country = geo.country;
  const region = geo.region;
  const continent = geo.continent;

  return (group) => {
    const regions = group.r ?? group.regions ?? [];

    if (regions.length === 0) {
      return false;
    }

    if (isGeoExcluded(regions, country, region, continent)) {
      return false;
    }

    return isGeoIncluded(regions, country, region, continent);
  };
};
